import { Button } from "@tento-ui/components/button/button";
import { Storybook } from "@tento-ui/ui/storybook";
import { BookingReceipt } from "./booking-receipt";

const COFFEE_CHAT: BookingReceipt.Props = {
  hostName: "Ada Lovelace",
  linkTitle: "Coffee Chat",
  durationMinutes: 30,
  startTimeMs: Date.parse("2026-06-27T16:00:00.000Z"),
  timezone: "America/Los_Angeles",
  bookerName: "Grace Hopper",
  bookerEmail: "grace@example.com",
  receiptUrl:
    "https://calendar.lona.so/booking/ada/coffee-chat?confirmed=243f3702-0000-4000-8000-000000000000",
};

const INTRO_CALL: BookingReceipt.Props = {
  hostName: "Ada Lovelace",
  linkTitle: "Intro Call",
  durationMinutes: 60,
  startTimeMs: Date.parse("2026-07-02T17:30:00.000Z"),
  timezone: "America/New_York",
  bookerName: "Alan Turing",
  bookerEmail: "alan@example.com",
  receiptUrl:
    "https://calendar.lona.so/booking/ada/intro-call?confirmed=8c1b9f44-0000-4000-8000-000000000000",
};

export class BookingReceiptStoryBook extends Storybook.Default {
  title(): string {
    return "Booking Receipt";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Receipt (Coffee chat, 30 min)",
        render: () => BookingReceipt.makeWith(COFFEE_CHAT),
      },
      {
        title: "Open as modal (Intro call, 60 min)",
        render: () =>
          Button.makeWithLight("Show receipt", {
            type: "primary",
            onClick: () => void BookingReceipt.show(INTRO_CALL),
          }),
      },
    ];
  }
}
